// Generated by purs version 0.15.15
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var PLIsSymbol = {
    reflectSymbol: function () {
        return "PL";
    }
};
var GBIsSymbol = {
    reflectSymbol: function () {
        return "GB";
    }
};
var RUIsSymbol = {
    reflectSymbol: function () {
        return "RU";
    }
};
var ROIsSymbol = {
    reflectSymbol: function () {
        return "RO";
    }
};
var CZIsSymbol = {
    reflectSymbol: function () {
        return "CZ";
    }
};
var HRIsSymbol = {
    reflectSymbol: function () {
        return "HR";
    }
};
var SKIsSymbol = {
    reflectSymbol: function () {
        return "SK";
    }
};
var DEIsSymbol = {
    reflectSymbol: function () {
        return "DE";
    }
};
var NLIsSymbol = {
    reflectSymbol: function () {
        return "NL";
    }
};
var ESIsSymbol = {
    reflectSymbol: function () {
        return "ES";
    }
};
var BRIsSymbol = {
    reflectSymbol: function () {
        return "BR";
    }
};
var ITIsSymbol = {
    reflectSymbol: function () {
        return "IT";
    }
};
var SIIsSymbol = {
    reflectSymbol: function () {
        return "SI";
    }
};
var RSIsSymbol = {
    reflectSymbol: function () {
        return "RS";
    }
};
var genericTopConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments);
var genericBottomConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments);
var genericBottomSum = /* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(genericBottomConstructor);
var genericEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments);
var genericEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
var genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum);
var genericBoundedEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments);
var genericBoundedEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(genericBoundedEnumConstructor);
var genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor)))))))))))));
var PL = /* #__PURE__ */ (function () {
    function PL() {

    };
    PL.value = new PL();
    return PL;
})();
var GB = /* #__PURE__ */ (function () {
    function GB() {

    };
    GB.value = new GB();
    return GB;
})();
var RU = /* #__PURE__ */ (function () {
    function RU() {

    };
    RU.value = new RU();
    return RU;
})();
var RO = /* #__PURE__ */ (function () {
    function RO() {

    };
    RO.value = new RO();
    return RO;
})();
var CZ = /* #__PURE__ */ (function () {
    function CZ() {

    };
    CZ.value = new CZ();
    return CZ;
})();
var HR = /* #__PURE__ */ (function () {
    function HR() {

    };
    HR.value = new HR();
    return HR;
})();
var SK = /* #__PURE__ */ (function () {
    function SK() {

    };
    SK.value = new SK();
    return SK;
})();
var DE = /* #__PURE__ */ (function () {
    function DE() {

    };
    DE.value = new DE();
    return DE;
})();
var NL = /* #__PURE__ */ (function () {
    function NL() {

    };
    NL.value = new NL();
    return NL;
})();
var ES = /* #__PURE__ */ (function () {
    function ES() {

    };
    ES.value = new ES();
    return ES;
})();
var BR = /* #__PURE__ */ (function () {
    function BR() {

    };
    BR.value = new BR();
    return BR;
})();
var IT = /* #__PURE__ */ (function () {
    function IT() {

    };
    IT.value = new IT();
    return IT;
})();
var SI = /* #__PURE__ */ (function () {
    function SI() {

    };
    SI.value = new SI();
    return SI;
})();
var RS = /* #__PURE__ */ (function () {
    function RS() {

    };
    RS.value = new RS();
    return RS;
})();
var eqCountry = {
    eq: function (x) {
        return function (y) {
            if (x instanceof PL && y instanceof PL) {
                return true;
            };
            if (x instanceof GB && y instanceof GB) {
                return true;
            };
            if (x instanceof RU && y instanceof RU) {
                return true;
            };
            if (x instanceof RO && y instanceof RO) {
                return true;
            };
            if (x instanceof CZ && y instanceof CZ) {
                return true;
            };
            if (x instanceof HR && y instanceof HR) {
                return true;
            };
            if (x instanceof SK && y instanceof SK) {
                return true;
            };
            if (x instanceof DE && y instanceof DE) {
                return true;
            };
            if (x instanceof NL && y instanceof NL) {
                return true;
            };
            if (x instanceof ES && y instanceof ES) {
                return true;
            };
            if (x instanceof BR && y instanceof BR) {
                return true;
            };
            if (x instanceof IT && y instanceof IT) {
                return true;
            };
            if (x instanceof SI && y instanceof SI) {
                return true;
            };
            if (x instanceof RS && y instanceof RS) {
                return true;
            };
            return false;
        };
    }
};
var ordCountry = {
    compare: function (x) {
        return function (y) {
            if (x instanceof PL && y instanceof PL) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof PL) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof PL) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof GB && y instanceof GB) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof GB) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof GB) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof RU && y instanceof RU) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof RU) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof RU) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof RO && y instanceof RO) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof RO) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof RO) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof CZ && y instanceof CZ) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof CZ) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof CZ) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof HR && y instanceof HR) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof HR) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof HR) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof SK && y instanceof SK) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof SK) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof SK) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof DE && y instanceof DE) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof DE) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof DE) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof NL && y instanceof NL) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof NL) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof NL) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ES && y instanceof ES) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof ES) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ES) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof BR && y instanceof BR) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof BR) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof BR) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof IT && y instanceof IT) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof IT) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof IT) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof SI && y instanceof SI) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof SI) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof SI) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof RS && y instanceof RS) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Countries (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqCountry;
    }
};
var genericCountry = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return PL.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return GB.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return RU.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return RO.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return CZ.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return HR.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return SK.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return DE.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return NL.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return ES.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return BR.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
            return IT.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))))) {
            return SI.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))))))))))) {
            return RS.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Countries (line 18, column 1 - line 18, column 69): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof PL) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof GB) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof RU) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof RO) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof CZ) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))));
        };
        if (x instanceof HR) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof SK) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof DE) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))));
        };
        if (x instanceof NL) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))));
        };
        if (x instanceof ES) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
        };
        if (x instanceof BR) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        if (x instanceof IT) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        if (x instanceof SI) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))))));
        };
        if (x instanceof RS) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)))))))))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Countries (line 18, column 1 - line 18, column 69): " + [ x.constructor.name ]);
    }
};
var showCountry = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCountry)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(PLIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(GBIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(RUIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ROIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CZIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(HRIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(SKIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(DEIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(NLIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ESIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(BRIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ITIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(SIIsSymbol))(/* #__PURE__ */ genericShowConstructor(RSIsSymbol)))))))))))))))
};
var unscrambleDecodeCountry = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericCountry)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(PLIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(GBIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(RUIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(ROIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(CZIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(HRIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(SKIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(DEIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(NLIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(ESIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(BRIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(ITIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(SIIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(RSIsSymbol)))))))))))))))(Unscramble_Enum.defaultEnumOptions)
};
var ufromJSONKeyCountry = {
    fromJSONKey: /* #__PURE__ */ Unscramble.defaultFromJSONKeyValue(unscrambleDecodeCountry)
};
var boundedCountry = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericCountry)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(genericTopConstructor)))))))))))))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericCountry)(genericBottomSum),
    Ord0: function () {
        return ordCountry;
    }
};
var enumCountry = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericCountry)(genericEnumSum1),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericCountry)(genericEnumSum1),
    Ord0: function () {
        return ordCountry;
    }
};
var boundedEnumCountry = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericCountry)(genericBoundedEnumSum1),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericCountry)(genericBoundedEnumSum1),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericCountry)(genericBoundedEnumSum1),
    Bounded0: function () {
        return boundedCountry;
    },
    Enum1: function () {
        return enumCountry;
    }
};
var toFillFormTypeCountry = {
    fillFormDataType: /* #__PURE__ */ Restaumatic_Form_TestHelpers.defaultEnumFillFormDataType(genericCountry)(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(PLIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(GBIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(RUIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(ROIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(CZIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(HRIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(SKIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(DEIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(NLIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(ESIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(BRIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(ITIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(SIIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(RSIsSymbol)))))))))))))))
};
var encodeCountry = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericCountry)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(PLIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(GBIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(RUIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(ROIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(CZIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(HRIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(SKIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(DEIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(NLIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(ESIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(BRIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(ITIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(SIIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(RSIsSymbol)))))))))))))))
};
var decodeCountry = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericCountry)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(PLIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(GBIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(RUIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(ROIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(CZIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(HRIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(SKIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(DEIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(NLIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(ESIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(BRIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(ITIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(SIIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(RSIsSymbol)))))))))))))))
};
var asJSONKeyCountry = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new Data_Map_Serialized.AsJSONKeyValue(Foreign_Generic_Class.encode(encodeCountry), Foreign_Generic_Class.decode(decodeCountry))
    };
})();
export {
    PL,
    GB,
    RU,
    RO,
    CZ,
    HR,
    SK,
    DE,
    NL,
    ES,
    BR,
    IT,
    SI,
    RS,
    genericCountry,
    eqCountry,
    showCountry,
    asJSONKeyCountry,
    ufromJSONKeyCountry,
    ordCountry,
    encodeCountry,
    decodeCountry,
    unscrambleDecodeCountry,
    enumCountry,
    boundedCountry,
    boundedEnumCountry,
    toFillFormTypeCountry
};
